import { render, staticRenderFns } from "./Detail-Cart.vue?vue&type=template&id=775b55a0"
import script from "./Detail-Cart.vue?vue&type=script&lang=js"
export * from "./Detail-Cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports